import { initSlider } from './common';

export default function initFeaturedTopicsBlock() {
    const blocks = [].slice.call(document.querySelectorAll('.ftdtopics'));
    blocks.forEach(initFeaturedTopic);
}

function initFeaturedTopic(block) {
    for (const sliderContainerEl of block.querySelectorAll('.swiper-container')) {
        const slidesPerView = parseFloat(sliderContainerEl.dataset.slidesPerView) || 'auto';

        const breakpoints = {};
        if (slidesPerView !== 'auto') {
            const decimalPart = slidesPerView % 1;
            breakpoints[320] = { slidesPerView: 1 + decimalPart };
            if (slidesPerView >= 2) {
                breakpoints[540] = { slidesPerView: 2 + decimalPart };
            }
            if (slidesPerView >= 3) {
                breakpoints[768] = { slidesPerView: 3 + decimalPart };
            }
            if (slidesPerView >= 4) {
                breakpoints[900] = { slidesPerView };
            }
        }

        initSlider(sliderContainerEl, {
            slidesPerView,
            breakpoints,
        });
    }
}
